import { CustomDatePicker } from './style.module';

export const DatePicker = CustomDatePicker;
